// Context que expone los modelos guardados REALES del usuario (globales +
// privados, ya con URLs firmadas) a los componentes de Interfaz V2 que los
// necesitan — en particular las tool cards del chat del agente, que antes
// listaban `MOCK_MODELS_V2` (fotos stock) en vez de los modelos reales.
//
// Default = array vacío. Lo provee InterfazV2 con el `userModels` que ya
// fetchea vía `fetchUserModels(companyId)`.

import { createContext, useContext } from 'react';
import type { ModelV2 } from './modelsApi';

export const ModelsContext = createContext<ModelV2[]>([]);

export const useUserModels = (): ModelV2[] => useContext(ModelsContext);
